
import Slider from "react-slick";
import React from "react";

const defaultSettings = {
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  infinite: true,
  arrows: false,
  centerMode: true,
  centerPadding: "350px",
 autoplaySpeed: 4000,
  speed: 5000,  
  cssEase: "ease",
  responsive: [
    { breakpoint: 1029, settings: { slidesToShow: 2, centerPadding: "0px", } },
    { breakpoint: 991, settings: { slidesToShow: 2, centerPadding: "0px", } },
    { breakpoint: 767, settings: { slidesToShow: 1, centerPadding: "80px", } },
    { breakpoint: 599, settings: { slidesToShow: 1, centerPadding: "0px", } },
  ],
};
export default function HomeTestimonial({ data = [] }) {

  return (
    <section className="home-testimonial">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-9">
            <div className="testimonial-text">
              <div className="center-heading">
                <h3 className="heading">Trusted Client Feedback</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Slider {...defaultSettings} className="testimonial-sliders">
        {data.map((item, index) => (
          <div className="testimonial-cols" key={index}>
            <div className="testimonial-sec">
              <div className="testimonial-cols-inner">
                <img src="/assets/images/quotes-left.webp" className="supershine-quote-left" alt="Quote" />
                <div className="testimonial-right">
                  <p>{item.text}</p>
                  <div className="testimonial-author">
                    <div className="testimonial-img">
                      <img src={item.image} alt={item.name} />
                    </div>
                    <div className="testimonial-content">
                      <div className="name">{item.name}</div>
                      <div className="des">{item.designation}</div>
                    </div>
                  </div>
                </div>
              </div>
              <img src="/assets/images/quotes-right.webp" className="supershine-quote-right"  alt="Quote"/>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}
